

<template>
	<div>
		<compWrapper theme="primary" title="基本信息">
			<compFormQuery
				:formdata="getBase"
				:labelWidth="120"
				:value="formData"
				class="margin-layout"
				v-if="type=='query'"
			></compFormQuery>
			<compFormEdit
				:formdata="getBase"
				:labelWidth="120"
				class="margin-layout"
				ref="formbase"
				v-else
				v-model="formData"
			/>
			<vButtonGroup class="text-right padding-right-10">
				<vButton @click="submit" class="margin-right-10" theme="primary" v-if="type!=='query'">确认</vButton>
				<vButton @click="close">返回</vButton>
			</vButtonGroup>
		</compWrapper>
		<!-- 弹框 -->
		<!-- <compModal @on-close="operate.show=false" v-bind="operate" v-model="operate.show">
			<component
				:is="operate.component"
				@on-close="operate.show=false"
				v-bind="operate.props"
				v-if="operate.component"
				v-on="operate.on"
			/>
		</compModal>-->
		<vLoading loading size="large" transfer v-if="loading"></vLoading>
	</div>
</template>

<script>
import mixin from '../mixin'
import { HttpUpdateAttachmentRule, HttpAttachmentRule } from "@/service/ucadm";
export default {
	mixins: [mixin],
	data() {
		return {
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			formData: {
				modelId: "",
				typeId: "",
				serviceProvider: 3,
				spMeta: "",
				envType: "",
			},
			spMeta: {}
		}
	},
	created() {
		this.getDetial()
	},
	computed: {
		getBase() {
			return [
				{
					label: '环境类型',
					key: 'envType',
					tag: 'vSelect',
					options: this.getEnvTypes,
				},
				{
					label: '模型',
					key: 'modelId',
					tag: 'vSelect',
					options: this.getAttachmentModels,
					props: {
						filterable: true
					}
				},
				{
					label: '类型',
					key: 'typeId',
					tag: 'vSelect',
					options: this.getAttachmentTypes,
				},
				{
					label: '服务提供商',
					key: 'serviceProvider',
					tag: 'vRadio',
					custom: true,
					options: this.getServiceProvider,
					required: false,
					props: {
						strict: false,
					}
				},
                {
                    label: 'bucket空间',
                    key: 'bucket',
                    tag: 'vInput',
                },
                {
                    label: 'epGet获取(默认)地址前缀',
                    key: 'epGet',
                    tag: 'vInput',
                    required: false,
                },
                {
                    label: 'epGa分发加速(CDN+ACC)地址前缀',
                    key: 'epGa',
                    tag: 'vInput',
                    required: false,
                },
                {
                    label: 'epCdn内容分发(CDN)地址前缀',
                    key: 'epCdn',
                    tag: 'vInput',
                    required: false,
                },
                {
                    label: 'epAcc传输加速(ACC)地址前缀',
                    key: 'epAcc',
                    tag: 'vInput',
                    required: false,
                },
                {
                    label: 'epPub公网访问',
                    key: 'epPub',
                    tag: 'vInput',
                },
                {
                    label: 'epVpcVPC网络访问',
                    key: 'epVpc',
                    tag: 'vInput',
                },
                {
                    label: 'region区域',
                    key: 'region',
                    tag: 'vInput',
                },
				{
					label: 'apiKey账号key',
					key: 'apiKey',
					tag: 'vInput',
				},
                {
                    label: 'apiSecret账号密码',
                    key: 'apiSecret',
                    tag: 'vInput',
                },
				{
					label: 'apiId账号id号',
					key: 'apiId',
					tag: 'vInput',
				},
				// {
				// 	label: '服务商相关信息',
				// 	key: 'spMeta',
				// 	tag: 'vTextarea',
				// },
                {
                    label: '默认占位链接(无则留空)',
                    key: 'defaultUrl',
                    tag: 'vInput',
                    required: false,
                },
                {
                    label: '附件默认分发模式(不设定留空/inline内嵌/attachment下载)',
                    key: 'dispositionDefault',
                    tag: 'vInput',
                    required: false,
                },
			]
		}
	},


	methods: {
		close() {
			this.$router.push({
				name: 'attachmentrule'
			})
		},
		//获取详情
		async getDetial() {
			if (this.type === 'add') return
			this.loading = true
			HttpAttachmentRule({ id: this.id }).then(res => {
				this.formData = res.data.entity || {};
				this.spMeta = JSON.parse(this.formData.spMeta || "{}")
				this.formData = {
					...this.formData,
					...this.handleTransferData(this.spMeta)
				}
				this.loading = false
			}).catch(err => {
				this.$VMessage.error(err.message)
				this.loading = false
			})
		},
		//保存数据
		async submit() {
			const valid = await this.$refs.formbase.validate()
			if (!valid) return
			this.loading = true;
			const formData = { ...this.formData };
			formData.spMeta = JSON.stringify({
				...this.spMeta,
				...this.handleTransferData(formData)
			})
			HttpUpdateAttachmentRule(formData).then(this.close).catch(err => {
				this.loading = false
				this.$VMessage.error(err.message)
			})
		},
		handleTransferData(data) {
			const keys = ['apiKey', 'apiId', 'bucket', 'apiSecret', 'epGet', 'epGa', 'epCdn', 'epAcc', 'epPub', 'epVpc', 'region', 'dispositionDefault'];
			const json = {};
			keys.forEach((key) => {
				json[key] = data[key];
				delete data[key];
			})
			return json;
		},
	}
}
</script>
